import { useEffect, useState, type Dispatch, type SetStateAction } from 'react';

export type ProcessListPopoverState = {
  title: string;
  items: string[];
  top: number;
  left: number;
};

/**
 * Shared popover target for actors/systems count cells on process tables.
 */
export function useProcessListPopover(): {
  listPopover: ProcessListPopoverState | null;
  setListPopover: Dispatch<SetStateAction<ProcessListPopoverState | null>>;
} {
  const [listPopover, setListPopover] = useState<ProcessListPopoverState | null>(null);

  useEffect(() => {
    const handleDocumentClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;
      if (
        listPopover &&
        !target?.closest?.('[data-process-list-popover]') &&
        !target?.closest?.('[data-process-list-trigger]')
      ) {
        setListPopover(null);
      }
    };
    document.addEventListener('mousedown', handleDocumentClick);
    return () => document.removeEventListener('mousedown', handleDocumentClick);
  }, [listPopover]);

  return { listPopover, setListPopover };
}
